import L from 'leaflet';
import { colorMap, normalizeStatus } from '../../../config/layerDictionary.js';
const layerBlocoEntrega = "Blocos de Entrega";

export function getStyleLayer(feature, layerName, isLineGeometry) {
  let colorBorder;
  let opacityBackground;
  const status = normalizeStatus(feature.properties?.status);

  if (layerName === layerBlocoEntrega && !isLineGeometry) {
    colorBorder = 'blue';
    opacityBackground = 0.07;
  }
  else if (layerName !== layerBlocoEntrega && status === "À executar" && !isLineGeometry) {
    colorBorder = 'gray';
    opacityBackground = 0.5;
  }
  else {
    colorBorder = colorMap[status];
    opacityBackground = 0.5;
  }

  return {
    color: colorBorder,
    weight: 2,
    fillOpacity: opacityBackground,
    opacity: 1,
    fillColor: layerName === layerBlocoEntrega ? 'blue' : colorMap[status],
  };
}

export function createStyleTooltip(feature, layerName, layer, loteSelecionado) {
  if (layerName !== layerBlocoEntrega) return null;
  const lote = feature.properties?.lote || "Sem nome";

  if (loteSelecionado !== null && lote !== parseInt(loteSelecionado)) return null;
  const bloco = feature.properties?.blocos || "Sem nome";
  const labelText = `${bloco}`;
  const tooltipPane = document.querySelector('.leaflet-tooltip-pane');

  if (tooltipPane) tooltipPane.classList.remove('hidden-labels');

  if (layer.getBounds) {
    const center = layer.getBounds().getCenter();
    const tooltip = L.tooltip({
      permanent: true,
      direction: 'center',
      className: 'custom-label'
    })
      .setLatLng(center)
      .setContent(labelText);

    tooltip.on('add', () => {
      const el = tooltip.getElement();

      const bgColor = 'rgba(0, 0, 255, 0.2)';
      if (el) {
        el.style.backgroundColor = bgColor;
        el.style.color = '#000';
        el.style.setProperty('color', '#FFF', 'important');
        el.style.setProperty('font-weight', 'bold', 'important');
        el.style.setProperty('text-align', 'center', 'important');
      }
    });
    return tooltip;
  }
  return null;
}